// Thin wrapper around window.location.reload so callers can be unit-tested without fighting
// jsdom's read-only window.location.
export const reloadPage = () => window.location.reload();
